module.exports = __webpack_public_path__ + "img/house2.fff11545.png";